import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "results"]
  static values = { debounceMs: Number }

  connect() {
    this.debounceTimeout = null
    this.setupEventListeners()
  }

  disconnect() {
    this.removeEventListeners()
  }

  setupEventListeners() {
    this.inputTarget.addEventListener('input', this.handleInput.bind(this))
    this.buttonTarget.addEventListener('click', this.handleSearch.bind(this))
    this.resultsTarget.addEventListener('click', this.handleResultClick.bind(this))
    document.addEventListener('click', this.handleOutsideClick.bind(this))
  }

  removeEventListeners() {
    this.inputTarget.removeEventListener('input', this.handleInput.bind(this))
    this.buttonTarget.removeEventListener('click', this.handleSearch.bind(this))
    this.resultsTarget.removeEventListener('click', this.handleResultClick.bind(this))
    document.removeEventListener('click', this.handleOutsideClick.bind(this))
  }

  handleInput(event) {
    const query = event.target.value.trim()
    
    // Clear previous timeout
    clearTimeout(this.debounceTimeout)
    
    // Disable search button if no query
    this.buttonTarget.disabled = query.length < 2
    
    // Hide results if query is too short
    if (query.length < 2) {
      this.hideResults()
      return
    }
    
    // Debounce search
    this.debounceTimeout = setTimeout(() => {
      this.performSearch(query)
    }, this.debounceMsValue || 300)
  }

  handleSearch() {
    const query = this.inputTarget.value.trim()
    if (query.length >= 2) {
      this.performSearch(query, true)
    }
  }

  handleResultClick(event) {
    if (event.target.closest('.search-result-item')) {
      const slug = event.target.closest('.search-result-item').dataset.slug
      window.location.href = `/area/${slug}`
    }
  }

  handleOutsideClick(event) {
    if (!this.inputTarget.contains(event.target) && !this.resultsTarget.contains(event.target)) {
      this.hideResults()
    }
  }

  async performSearch(query, navigateToFirst = false) {
    try {
      const response = await fetch(`/search/locations?q=${encodeURIComponent(query)}`)
      const data = await response.json()
      
      if (data.length > 0) {
        if (navigateToFirst) {
          window.location.href = `/area/${data[0].value}`
        } else {
          this.displayResults(data)
        }
      } else {
        this.displayNoResults()
      }
    } catch (error) {
      console.error('Search failed:', error)
      this.displayError()
    }
  }

  displayResults(data) {
    const resultsHtml = data.map(item => {
      let locationInfo = []
      if (item.county) locationInfo.push(item.county)
      if (item.country) locationInfo.push(item.country)
      const locationText = locationInfo.length > 0 ? locationInfo.join(', ') : ''
      
      return `<div class="search-result-item p-2 border-bottom" data-slug="${item.value}">
        <strong>${item.text}</strong>
        ${locationText ? `<br><small class="text-muted">${locationText}</small>` : ''}
      </div>`
    }).join('')
    
    this.resultsTarget.innerHTML = resultsHtml
    this.showResults()
  }

  displayNoResults() {
    this.resultsTarget.innerHTML = '<div class="p-2 text-muted">No locations found</div>'
    this.showResults()
  }

  displayError() {
    this.resultsTarget.innerHTML = '<div class="p-2 text-danger">Search failed. Please try again.</div>'
    this.showResults()
  }

  showResults() {
    this.resultsTarget.style.display = 'block'
  }

  hideResults() {
    this.resultsTarget.style.display = 'none'
  }
}
